// // src/Components/Auth/ProtectedRoute.js
// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = localStorage.getItem('isAuthenticated'); // or use context

//   return isAuthenticated ? children : <Navigate to="/login" replace />;
// };

// export default ProtectedRoute;
// Components/ProtectedRoute/ProtectedRoute.js


import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated'); // or check token, etc.
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
